<template>
  <div class="px-8 py-1">
    <v-container grid-list-xl fluid class="px-0">
      <v-layout row wrap class="pr-3 mb-2">
        <v-flex xs8 class="pb-0">
          <h3 class="darkblue--text fs-16 lh-16 font-weight-700">
            NON-PO REPORT
          </h3>
          <v-breadcrumbs
            class="
              px-0
              subtitle-2
              mt-2
              py-0
              breadcrumbs-items
              custom-breadcrumbs
            "
            :items="breadcrumbs"
          ></v-breadcrumbs>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          class="mt-3 mr-3"
          dark
          @click="downloadFile()"
          v-if="isLoggedInAsBO"
        >
          <!-- @click="downloadFile()" -->
          <v-icon size="10px">mdi-download</v-icon> Download
        </v-btn>
        <advance-filter
          :title="'Non - PO Monitoring Report'"
          @getFiltered="getFilteredFilter"
          class="mt-1"
          v-else
        />
        <v-flex xs2 class="text-center pb-0 pt-3 pl-0">
          <date-picker
            v-model="yearBo"
            type="year"
            placeholder="Budget Owner"
            format="YYYY"
            class="dashSearch filterSearch"
          >
          </date-picker>
        </v-flex>
      </v-layout>
      <v-flex
        xs12
        class="pa-0 grey--text font-weight-500 fs-12 lh-16 ml-3 pt-1"
        style="margin-top: -12px"
      >
        <v-row>
          <v-expansion-panels flat class="filterby-info">
            <v-expansion-panel>
              <v-expansion-panel-header
                class="grey--text fs-13 px-0 pt-0 pb-1 secondary"
                height="100px"
              >
                Filter By Information
              </v-expansion-panel-header>
              <v-expansion-panel-content class="grey--text secondary">
                <ul v-if="filterBy.length > 0">
                  <li
                    v-for="(filter, indexFilter) in filterBy"
                    :key="'filter' + indexFilter"
                    class="text-left"
                  >
                    {{ yearInfo }}
                    <template v-for="(detail, indexDetail) in filter">
                      {{ ' / ' }}
                      <span :key="'indexDetail-' + indexDetail">
                        {{ detail.map(e => e.name).join(' / ') }}
                      </span>
                    </template>
                  </li>
                </ul>
                <ul v-else>
                  <li>{{ yearInfo }}</li>
                </ul>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-row>
      </v-flex>
    </v-container>
    <v-layout class="table-non-po">
      <v-flex xs12>
        <v-card class="elevation-card rounded-12">
          <v-card-title class="mb-5">
            <v-flex xs9> NON-PO REPORT </v-flex>
            <v-flex xs3 class="text-right">
              <v-icon class="mr-4"></v-icon>
              <v-icon id="refresh" @click="getData(yearBo)"> refresh </v-icon>
            </v-flex>
          </v-card-title>
          <v-flex xs4 class="mb-5 px-5">
            <v-text-field
              id="search"
              v-model="searchColumn[0]"
              append-icon="search"
              placeholder="Search by IO Number"
              single-line
              hide-details
              @keyup="searchIO()"
            ></v-text-field>
          </v-flex>
          <v-data-table
            class="px-4 nav-table"
            :items="items"
            :options.sync="options"
            :server-items-length="totalItems"
            :footer-props="{
              itemsPerPageOptions: [10, 25, 50, 100]
            }"
          >
            <template v-slot:header>
              <thead>
                <tr>
                  <th>
                    IO Number
                    <filter-column
                      field="io_number"
                      :indexItem="0"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :isNonPO="true"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th>
                    IO Description
                    <filter-column
                      field="io_description"
                      :indexItem="1"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :isNonPO="true"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th>
                    Posting Date
                    <filter-column
                      field="posting_date"
                      :indexItem="2"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :isNonPO="true"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th>
                    Budget Owner
                    <filter-column
                      field="budget_owner"
                      :indexItem="3"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :isNonPO="true"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                  <th>
                    ANP Actual Amount
                    <filter-column
                      field="anp_actual_amount"
                      :indexItem="4"
                      @searchColumn="searchCln"
                      @sortBy="sortBy"
                      :listFilter="[]"
                      @checkColumn="checkColumn"
                      :year="yearBo"
                      :isNonPO="true"
                      :columnType="true"
                      :paramFiltered="paramFiltered"
                    />
                  </th>
                </tr>
              </thead>
            </template>
            <template v-slot:body="{ items }">
              <tbody v-if="items.length > 0">
                <tr v-for="(item, index) in items" :key="index">
                  <td>
                    {{ item.io_number ? item.io_number : '-' }}
                  </td>
                  <td>
                    {{ item.io_description ? item.io_description : '-' }}
                  </td>
                  <td>
                    {{
                      item.posting_date
                        ? formattedDate2(item.posting_date)
                        : '-'
                    }}
                  </td>
                  <td>
                    {{ item.budget_owner ? item.budget_owner : '-' }}
                  </td>
                  <td class="text-right">
                    {{
                      item.anp_actual_amount ? idr(item.anp_actual_amount) : '-'
                    }}
                  </td>
                </tr>
                <tr class="bgTotal">
                  <td colspan="4" class="font-weight-bold text-right">TOTAL</td>
                  <td class="text-right font-weight-bold">
                    {{ totalAmountFor('anp_actual_amount') }}
                  </td>
                </tr>
                <tr class="bgTotal">
                  <td colspan="4" class="font-weight-bold text-right">
                    TOTAL NON-PO AMOUNT
                  </td>
                  <td class="text-right font-weight-bold">
                    {{ idr(amountTotal) }}
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="5" class="text-center">No data displayed</td>
                </tr>
              </tbody>
            </template>
            <template v-slot:no-data>
              <label color="primary">No data displayed</label>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>

    <progress-dialog :show="progressDialogLoading" text="Please wait">
    </progress-dialog>
  </div>
</template>

<script>
import ProgressDialog from '../../../components/progress_dialog';
import ACLMixin from '../../../mixins/ACLMixin';
import Swal from 'sweetalert2';
import moment from 'moment';
// import VuePerfectScrollbar from 'vue-perfect-scrollbar';
// import advanceFilter from '../../../components/advanceFilter/selectFilter';
import advanceFilter from '@/components/advanceFilter/DynamicFilter';
import filterColumn from '@/components/filterColumn/monitoring';

export default {
  components: {
    'progress-dialog': ProgressDialog,
    // VuePerfectScrollbar,
    'advance-filter': advanceFilter,
    'filter-column': filterColumn
  },
  mixins: [ACLMixin],
  props: ['yearIo', 'io'],
  data() {
    return {
      scrollSettings: {
        maxScrollbarLength: 260
      },
      scrollSettingsEdit: {
        maxScrollbarLength: 220
      },
      progressDialogLoading: true,
      breadcrumbs: [
        {
          text: 'PO & NON PO MONITORING',
          disabled: true,
          href: 'breadcrumbs_dashboard'
        },
        {
          text: 'NON-PO REPORT',
          disabled: true,
          href: 'breadcrumbs_link_1'
        }
      ],
      year: new Date(),
      showYear: moment(new Date()).format('YYYY'),
      headers: [
        {
          text: 'IO Number',
          value: 'io_number',
          sortable: false
        },
        {
          text: 'IO Description',
          value: 'io_desc',
          sortable: false
        },
        {
          text: 'Posting Date',
          value: 'posting_date',
          sortable: false
        },
        {
          text: 'Budget Owner',
          value: 'internalOrder.budgetOwner.desc',
          sortable: false
        },
        {
          text: 'ANP Actual Amount',
          value: 'amount',
          sortable: false
        }
      ],
      items: [],
      descending: true,
      sort: '',
      totalItems: 0,
      options: {
        itemsPerPage: 10
      },
      // advance filter properties
      filters: [],
      filter: '',
      isDisabledHouse: false,
      isDisabledDept: false,
      isDisabledBo: false,
      showFilterDialog: false,
      divisionFil: [],
      isDivision: true,
      houseFil: [],
      isHouse: true,
      deptFil: [],
      isDept: true,
      boFil: [],
      isBo: true,
      divisionList: [],
      houseList: [],
      deptList: [],
      boList: [],
      userLevel: [],
      baseUrl: process.env.VUE_APP_BASE_URL,
      yearBo: new Date(),
      amount: null,
      isSearch: false,
      search: '',
      filterby: '',
      amountTotal: 0,
      searchColumn: [],
      searchChecked: [],
      sortColumn: [],
      divId: [],
      groupId: [],
      boId: [],
      filterBy: '',
      paramFiltered: [
        {
          divisionIds: [],
          houseIds: [],
          groupIds: [],
          budgetOwnerIds: []
        }
      ]
    };
  },
  watch: {
    yearBo(value) {
      this.getData(value);
    },
    'options.page'() {
      this.getData(this.yearBo);
    },
    'options.itemsPerPage'() {
      this.getData(this.yearBo);
    }
  },
  computed: {
    yearInfo() {
      return moment(this.yearBo).format('YYYY');
    }
  },
  async mounted() {
    let path = this.$route.fullPath;
    let page = path.split('/').join('');
    if (page.includes('search')) {
      this.yearBo = new Date(this.yearIo, 1, 1);
      this.searchColumn[0] = this.io;
    }
    await this.getData(this.yearBo);
  },
  methods: {
    getFilteredFilter(val) {
      this.filterBy = val.info;
      this.paramFiltered = val.param;
      if (val.type === 'download') {
        this.downloadFile();
      } else {
        this.getData(this.yearBo);
      }
    },
    searchCln(obj) {
      this.searchColumn = [];
      this.searchColumn[obj.index] = obj.value;
      this.isSearch = true;
      this.getData(this.yearBo);
    },
    checkColumn(obj) {
      this.searchChecked = [];
      this.isSearch = true;
      if (obj.type === 'clear') {
        this.getData(this.yearBo);
      } else {
        this.searchChecked[obj.index] = obj.value;
        this.getData(this.yearBo);
      }
    },
    sortBy(obj) {
      this.isSearch = true;
      this.sortColumn[0] = obj.fieldName;
      this.sortColumn[1] = obj.value;
      this.getData(this.yearBo);
    },
    getParam(obj) {
      console.log(obj);
      this.filterby = obj.filter;
      this.divisionFil = obj.divId;
      this.houseFil = obj.houseId[0] === null ? '' : obj.houseId;
      this.deptFil = obj.deptId;
      this.boFil = obj.boId;
      this.yearBo = obj.year;
      if (obj.type === 'set') {
        this.getData(obj.year);
      } else {
        this.downloadFile();
      }
    },
    searchIO() {
      this.isSearch = true;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getData(this.yearBo);
      }, 900);
    },
    totalAmountFor(key) {
      let amountFor = this.items.reduce((total, item) => {
        const value = +(item[key] || 0);
        total += value;
        return total;
      }, 0);
      if (Number(amountFor) === 0) {
        return '-';
      } else {
        return this.idr(Math.round(amountFor));
      }
    },
    totalAmount(val) {
      if (Number(val) === 0) {
        return '-';
      } else {
        return this.idr(val);
      }
    },
    getData(year) {
      this.progressDialogLoading = true;
      this.loading = true;
      this.showYear = moment(year).format('YYYY');
      let date = new Date();
      if (!year) {
        year = moment(date).format('YYYY');
      } else {
        year = moment(year).format('YYYY');
      }
      let { page, itemsPerPage } = this.options;
      if (this.isSearch) {
        page = 1;
      }
      const search = {
        io_number: this.searchColumn[0],
        io_description: this.searchColumn[1],
        posting_date: this.searchColumn[2],
        budget_owner: this.searchColumn[3],
        anp_actual_amount: this.searchColumn[4]
      };
      const filters = {
        io_number: this.searchChecked[0],
        io_description: this.searchChecked[1],
        posting_date: this.searchChecked[2],
        budget_owner: this.searchChecked[3],
        anp_actual_amount: this.searchChecked[4]
      };
      const sort = {
        field: this.sortColumn[0],
        sort: this.sortColumn[1]
      };
      return this.$store
        .dispatch('purchasingOrder/getNonPO', {
          year,
          page,
          limit: itemsPerPage,
          filter: this.paramFiltered,
          search,
          filters,
          sorting: this.sortColumn.length > 0 ? sort : ''
        })
        .then(data => {
          this.progressDialogLoading = false;
          this.loading = false;
          this.isSearch = false;
          if (data.code === 200) {
            this.items = data.data.data;
            this.amountTotal = data.data.sum;
            this.amount = data.data.total_amount;
            this.totalItems = Number(data.data.total);
            page = data.data.page;
            itemsPerPage = data.data.perPage;
            this.options = { page, itemsPerPage };
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          this.progressDialogLoading = false;
          this.loading = false;
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
        });
    },
    downloadFile() {
      let filters = '';
      if (this.paramFiltered.length > 0) {
        for (var i = 0; i < this.paramFiltered.length; i++) {
          filters +=
            `&filter[]={"divisionIds":[${this.paramFiltered[i].divisionIds}],` +
            `"houseIds":[${this.paramFiltered[i].houseIds}],` +
            `"groupIds":[${this.paramFiltered[i].groupIds}],` +
            `"budgetOwnerIds":[${this.paramFiltered[i].budgetOwnerIds}]}`;
        }
      }
      let year = moment(this.yearBo).format('YYYY');
      let profile_id = localStorage.getItem('profile_id');
      window.open(
        this.baseUrl +
          '/v1/non-purchasing-orders/download/report?profile_id=' +
          profile_id +
          '&year=' +
          year +
          filters +
          '&token=' +
          localStorage.getItem('app_token'),
        '_blank'
      );
    }
  }
};
</script>
<style>
.table-non-po .v-data-table__wrapper {
  border-radius: 5px !important;
}
.table-non-po table {
  /* display: block; */
}
.table-non-po table th,
.table-non-po table td {
  white-space: nowrap !important;
  border: 1px solid rgba(0, 0, 0, 0.12);
}
/* width */
.table-non-po ::-webkit-scrollbar {
  height: 8px;
}
/* Track */
.table-non-po ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
.table-non-po ::-webkit-scrollbar-thumb {
  background: #d5d5d5;
  border-radius: 20px;
}

/* Handle on hover */
.table-non-po ::-webkit-scrollbar-thumb:hover {
  background: #bbb;
}
.table-non-po .theme--light.v-data-table thead tr th {
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 17px !important;
  letter-spacing: -0.02em !important;
  text-align: center !important;
  border-right: 1px solid #0000001f;
  height: 37px !important;
  color: #fff !important;
  background: #28a0f6 !important;
}
.table-non-po .theme--light.v-data-table tbody td {
  height: 30px !important;
  border-right: 0.5px solid rgba(0, 0, 0, 0.12);
  border-left: 0.5px solid rgba(0, 0, 0, 0.12);
}
.filterby-info .v-expansion-panel-header__icon {
  margin-left: 0px !important;
}
</style>
